import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle } from "components/ui/dialog";
import CollapseIcon from "./../../../../../assets/icons/collapse_icon.png";

interface Props {
  image: string;
  openImage: boolean;
  setOpenImage: (value: boolean) => void;
}

export default function FullLockerView({
  image,
  openImage,
  setOpenImage,
}: Props) {
  const { t } = useTranslation();

  const handleOpenChange = (next: boolean) => {
    if (!next) setOpenImage(false);
  };

  return (
    <Dialog open={openImage} onOpenChange={handleOpenChange}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        // Image lightbox: transparent surface, the photo is the content.
        className="w-[400px] max-w-[calc(100vw-2rem)] border-none bg-transparent p-2 shadow-none"
      >
        <DialogTitle className="sr-only">
          {t("common.dialog.locker_image")}
        </DialogTitle>
        <div className="relative">
          <button
            type="button"
            onClick={() => setOpenImage(false)}
            aria-label={t("common.close")}
            className="absolute bg-black/50 h-6 w-6 rounded-md right-2 top-2 flex items-center justify-center"
          >
            <img className="h-4 object-cover" src={CollapseIcon} alt="" />
          </button>
          <img
            className="h-[70vh] w-full object-cover rounded-md"
            src={image}
            alt="locker"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
